var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "filter-countries" },
    [
      _c("el-input", {
        attrs: { placeholder: `Search within ${_vm.region.name}` },
        model: {
          value: _vm.input,
          callback: function ($$v) {
            _vm.input = $$v
          },
          expression: "input",
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.countriesList, function (item) {
        return _c(
          "div",
          {
            key: item.tid,
            staticClass: "jurisdictions__country-six",
            class: { full: item.nestedChildren && item.nestedChildren.length },
          },
          [
            _c("CountryWithPopover", {
              class: {
                transparent: _vm.currentTid && _vm.currentTid !== item.tid,
              },
              attrs: {
                name: item.name,
                tid: item.tid,
                hub: item.huburl,
                reports: item.reports,
                flag: item.flagurl,
                subscribed: item.subscribed,
              },
              on: { popOverChange: _vm.selectPopover },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }